import React, { useEffect, useState } from "react";
import "./HomeNew.css";
import NavBar from "../Components/NavBar/NavBar";
import SideBar from "../Components/SideBar";
import { Outlet } from "react-router-dom";
import { RxHamburgerMenu } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import NewSidebar from "../Components/NewComponents/NewSidebar";
import NewSidebarOld from "../Components/NewComponents/NewSidebarOld";

const HomeNew = () => {
  const navigate = useNavigate();

  //   const [showSideBar, setShowSideBar] = useState(false);
  const [showSideBar, setShowSideBar] = useState(true);
  const [shrinkSidePanel, setShrinkSidePanel] = useState(true);
  
  const [showFullSidePanel, setShowFullSidePanel] = useState(false);
  const [isModulePanelExpanded, setIsModulePanelExpanded] = useState(true);

  const userData = JSON.parse(localStorage.getItem("BondTimeLoginUserData"));

  // Check if user is logged in and has "Success" status
  const isAuthenticated = userData && userData[0]?.Userlogin === "Sucess";

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated]);

  const toggleShowSideBar = () => {
    setShowSideBar(!showSideBar);
  };

  const handleHomePage = () => {
    window.scrollTo(0, 0);
    navigate("/admin/home");
  };

  console.log("showSideBar", showSideBar);

  

  return (
    <>
      <div className="HomeNewWrapper">
        {/* sidebar */}
        <div
          className="HomeLeftCont"
          style={{
            // width: shrinkSidePanel ? "7%" : "20%",
            width: shrinkSidePanel ? "7%" : "20%",
          }}
        >
          {/* <div className="NewDashSideBarBigScreen "> */}

          {/* <div> */}
          {/* <SideBar
                setShowFullSidePanel={setShowFullSidePanel}
                showFullSidePanel={showFullSidePanel}
                toggleShowSideBar={toggleShowSideBar}
                setShowSideBar={setShowSideBar}
                setShrinkSidePanel={setShrinkSidePanel}
                shrinkSidePanel={shrinkSidePanel}
              /> */}
          {/* </div> */}
          {/* </div> */}




          {/* <div>
          <NewSidebar />
        </div> */}
          <div>
          <NewSidebarOld />
        </div>
          {/* <div>
            <NewSidebar
              isModulePanelExpanded={isModulePanelExpanded}
              setIsModulePanelExpanded={setIsModulePanelExpanded}
              // groupedModuleSubmoduleMain={groupedModuleSubmoduleMain}
              // currentSelectedMouleObject={currentSelectedMouleObject}
              // setCurrentSelectedMouleObject={setCurrentSelectedMouleObject}
            />
          </div> */}
        </div>

        {/* {showSideBar ? (
          <div className="NewDashSideBar">
            <SideBar
              setShowFullSidePanel={setShowFullSidePanel}
              showFullSidePanel={!showFullSidePanel}
              toggleShowSideBar={toggleShowSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        ) : (
          ""
        )} */}

        <div
          className="HomeRightCont"
          style={{
            width: shrinkSidePanel ? "94%" : "80%",
          }}
        >
          {/* navBar */}
          <div className="NewDashNav">
            <NavBar toggleShowSideBar={toggleShowSideBar} />
          </div>

          {/* outlet */}

          <div className="OutletWrap">
            <div className="NewDashBody main-body">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeNew;
